import { useMutation } from '../useMutation'
import { mutationQuery } from './graphql'

export const useSetRole = () => {
  return useMutation({
    query: mutationQuery,
  })
}
